

import React, { Component, Fragment } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import HighchartsMap from "highcharts/modules/map";
// import proj4 from "proj4";
// import mapDataIE from "@highcharts/map-collection/countries/in/in-all.geo.json";

import MsiReports from "./MsiReports";

// HighchartsMap(Highcharts);

class BubbleMapChart extends Component {

  
  handlePointClick = (event) => {

    // pass this event.point.options back to the MsiReports page using callback function from props
    // in the event.points.options we are getting prefilled lang, long, name and other details. We can use them instead of the lang, long given by this chart since it is changing
    this.props.onClick({selectedPoint: event.point.options})
  };
  render() {
    const options = {
      // chart: {
      //   map: mapDataIE,
      //   proj4,
      //   height: "300px",
      // },
      title: {
        text: ' ',
        enabled: true,
    },
      series: [
        // {
        //   type: "map",
        //   mapData: mapDataIE,
        //   borderColor: "#a0a0a0",
        //   nullColor: "rgba(255, 255, 255, 0.3)",
        //   showInLegend: false,
        // },
        {
          type: "mappoint",
          name: "Cities",
          dataLabels: {
            enabled: true,
            format: "{point.name}, {point.parentState}, {point.parentCountry}",
          },
          data: [
            {
              name: "Hyderabad",
              lat: 17.416097484930887,
              lon: 78.42907313237566,
              text:"total",
            },
            {
              name: "Banjara Hills",
              lat: 17.388037757256075,
              lon: 78.47050942229811,
            },
            {
              name : "Vijayawada",
              lat:16.51983225839451, 
              lon: 80.63721172510989
            },
            {
              name: "Bangalore",
              parentState: "Karnataka",
              parentCountry: "India",
              lat: 12.963827730849815,
              lon: 77.60338786726571,
              // total_patient: 15 - ee key aa tooltip and aa point onclick lo kuda this.point.options ane dhantlo untahdi
            },
          ],
          point: {
            events: {
              click: this.handlePointClick, // Attach click event handler
            },
          },
        },
      ],
      plotOptions: {
        series: {
          cursor: "pointer", // Enable cursor pointer on map points
          point: {
            events: {
              click: this.handlePointClick, // Attach click event handler
            },
          },
        },
      },
      credits: {
        enabled: false
    },
    tooltip: {
      shared: true,
      enabled: true,
      outside: true,
      split: true,
      // borderColor: Highcharts.getOptions().colors[2],
      formatter: function () {
     
        // in this line we can write html content for tooltip
        // this.point ane dhantloki automatic ga vacchesthadhi okavela miru kindha series lo em keys pedithe avi
        return '<b>'+this.point.options.name + "</b>"
      },
    },
      mapNavigation: {
        enabled: true, // Enable map navigation (zooming, panning)
      },
    };

    return (
      <Fragment>
        {/* <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"mapChart"}
        /> */}
      </Fragment>
    );
  }
}

export default BubbleMapChart;
